"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatisticsList = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../common");
const server_1 = require("../../../server");
const react_i18next_1 = require("react-i18next");
exports.StatisticsList = react_1.default.memo(({ id, onlyOne = false, searchOption, userType, initPage, defaultProps, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const countRef = react_1.default.useRef(10);
    const [page, setPage] = react_1.default.useState(initPage);
    const [totalCount, setTotalCount] = react_1.default.useState(0);
    const [testData, setTestData] = react_1.default.useState([]);
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        // 기본적인 항목들
        const headTitleList = [
            { title: 'siteName', space: 1 },
            { title: 'name', space: 1 },
            { title: 'idf', space: 1 },
            { title: 'phone', space: 1 },
            { title: 'role', space: 1 },
            { title: 'inviteKlass', space: 1 },
            { title: 'lastConnection', space: 1 },
        ];
        const tableReadDataKeys = [
            { title: 'tenant_id', space: 1 },
            { title: 'nickname', space: 1 },
            { title: 'identifier', space: 1 },
            { title: 'phone_number', space: 1 },
            { title: 'level_name', space: 1 },
            { title: 'found_classes', space: 1 },
            { title: 'last_accessed_time', space: 1 },
        ];
        return { headTitleList, tableReadDataKeys };
    }, []);
    // 해당 클래스에 해당하는 사용자 가져오기
    const { data, refetch } = (0, server_1.useMemberInfo)({
        ...(id ? { id } : {}),
        ...(searchOption ? { nickname_like: searchOption } : {}),
        ...(userType !== "00" ? { level: userType } : {}),
        offset: page * countRef.current,
        limit: countRef.current,
        orderby: ['level ASC', 'id'],
        with_more_info: true,
    });
    const refetchRef = react_1.default.useRef(refetch);
    refetchRef.current = refetch;
    // 렌더마다 throttle 인스턴스가 재생성되어 스로틀이 무효화되던 것 수정 — 단일 인스턴스 유지
    const refetchList = react_1.default.useMemo(() => (0, throttle_1.default)(() => refetchRef.current(), 1000, { leading: true, trailing: false }), []);
    react_1.default.useEffect(() => {
        refetchList();
    }, [id, searchOption, page, userType]);
    react_1.default.useEffect(() => {
        if (data) {
            const { total_count, items, found_count } = data;
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / countRef.current) - 1);
                if (page !== maxPage) {
                    setPage(maxPage);
                    return;
                }
                // 이미 maxPage 인데도 0건 → 서버 total_count·items 불일치. 빈 목록 처리로 폴스루해
                // empty 문구가 노출되게 한다(기존: totalCount 잔존/음수 페이지로 빈 화면·페이지네이션 소실).
            }
            else {
                if (items.length > 0) {
                    setTestData(items);
                    setTotalCount(total_count);
                    return;
                }
            }
        }
        setTestData([]);
        setTotalCount(0);
    }, [data, page]);
    react_1.default.useEffect(() => {
        setPage(initPage);
    }, [initPage]);
    const handlerMoreData = (page) => {
        setPage(page);
        APP.eventManager.publish('UPDATE_PAGE', page);
    };
    const handlerSelectItem = (item) => {
        APP.eventManager.publish('CHANGE_MENU', {
            showDepth: 'detail',
            props: { id: item.id },
        });
    };
    const renderEmpty = react_1.default.useMemo(() => totalCount <= 0 && (react_1.default.createElement("div", { className: "empty_data" },
        react_1.default.createElement("p", null, "\uB4F1\uB85D\uB41C \uC0AC\uC6A9\uC790\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."))), [totalCount]);
    const renderItem = (item) => {
        if (!item)
            return;
        return tableReadDataKeys.map((headItem, idx) => (react_1.default.createElement("div", { key: idx, className: "table-item", style: {
                flex: headItem.space,
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                overflow: 'hidden',
            } }, (() => {
            switch (headItem.title) {
                case 'nickname':
                    return (react_1.default.createElement("p", { className: "overText2 underline" }, item[headItem.title]));
                case 'phone_number':
                    if (!item[headItem.title])
                        return react_1.default.createElement("p", null, "-");
                    return react_1.default.createElement("p", { className: "overText2" }, item[headItem.title]);
                case 'last_accessed_time':
                    if (!item[headItem.title])
                        return react_1.default.createElement("p", null, "-");
                    return (react_1.default.createElement("p", { className: "overText2" }, (0, moment_1.default)(item[headItem.title]).format('YYYY-MM-DD, HH:mm')));
                case 'level_name':
                    return (react_1.default.createElement("p", { className: "overText2" }, t(`common.${item[headItem.title]}`)));
                case 'found_classes':
                    if (!item[headItem.title])
                        return react_1.default.createElement("p", null, "-");
                    return react_1.default.createElement("p", { className: "overText2" },
                        item[headItem.title].length,
                        " ");
                default:
                    return react_1.default.createElement("p", { className: "overText2" }, item[headItem.title]);
            }
        })())));
    };
    return (react_1.default.createElement(common_1.Table, { className: `header-center ${onlyOne ? 'table-white-grey' : ''}`, showIndex: true, indexOrder: "desc", isInnerPage: true, isInfinite: false, page: page, data: testData, totalCount: totalCount, headTitleList: headTitleList, renderItem: renderItem, renderEmpty: renderEmpty, handlerSelectItem: handlerSelectItem, handlerMoreData: handlerMoreData }));
});
